<template>
  <rect width="90" height="48" rx="3" fill="#3E3E3E" />
  <rect x="12.5" y="8.5" width="65" height="27" rx="2.5" fill="#525252" />
  <rect x="25" y="19" width="29" height="6" rx="2" fill="#757575" />
  <path
    d="M65.4624 23.7903C65.207 24.0699 64.793 24.0699 64.5376 23.7903L62.1928 21.2225C61.7809 20.7713 62.0726 20 62.6552 20H67.3448C67.9274 20 68.2191 20.7713 67.8072 21.2225L65.4624 23.7903Z"
    fill="#F9F9F9" />
  <rect x="12.5" y="8.5" width="65" height="27" rx="2.5" stroke="#5B5B5B" />
</template>
